import {Form, Table} from "antd";
import '../../assets/css/Dentobook.css';
import React, {useEffect, useState} from "react";
import {FormattedMessage} from "react-intl";
import dayjs from 'dayjs';
import {DentobookApplicationContext} from "../../context/DentobookApplicationContext";
import {Patient, StatusResponse, ToothTreatment, Treatment} from "../../api-client";
import {formatDate} from "../../i18n/utils";
import {getPatientApi, getMedicalStaffApi, getTreatmentsApi, getStatusesApi} from "../../api/apiInstances";
import logger from "../../utils/logger";

const Treatments: React.FC = () => {
    const [treatments, setTreatments] = useState<ToothTreatment[]>([]);
    const [medicalStatuses, setMedicalStatuses] = useState<Map<string, StatusResponse>>(new Map());
    const [medicalTreatments, setMedicalTreatments] = useState<Map<string, Treatment>>(new Map());
    const {locale} = React.useContext(DentobookApplicationContext);
    dayjs.locale(locale);

    const patientApi = getPatientApi();
    const medicalApi = getMedicalStaffApi();
    const treatmentsApi = getTreatmentsApi();
    const statusesApi = getStatusesApi();

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        patientApi.getAllTreatments()
            .then(res => {
                setTreatments(res.data!);
                statusesApi.fetchAllStatuses()
                    .then(res => {
                        const map = new Map();

                        for (const status of res.data) {
                            map.set(status.id, status);
                        }
                        setMedicalStatuses(map);
                        treatmentsApi.fetchMedicalTreatments()
                            .then(res => {
                                const map = new Map();

                                for (const treatment of res.data) {
                                    map.set(treatment.id, treatment);
                                }
                                setMedicalTreatments(map);
                            })
                            .catch(err => logger.log(err))
                    })
                    .catch(err => logger.log(err));
            })
            .catch(err => logger.log(err));
    };

    return (
        <>
            <div style={{paddingTop: '10px'}}>
                <Form.Item
                    className={"dentobook-form-item"}
                    rules={[{required: true, message: <FormattedMessage id="required_field"/>}]}
                >
                </Form.Item>
                <Table dataSource={treatments}
                       pagination={false}
                       loading={!treatments.length || !medicalStatuses.size || !medicalTreatments.size}
                       style={{paddingTop: '10px'}}
                       className="dentobook-table">
                    <Table.Column key="date" width="15%" title={<FormattedMessage id="date"/>}
                                  sorter={(a: ToothTreatment, b: ToothTreatment) => a.date!.localeCompare(b.date!)}
                                  render={(treatment: ToothTreatment) => <span
                                      className="font-weight-500">{formatDate(treatment.date)}</span>}
                    />
                    <Table.Column key="condition"
                                  render={(treatment: ToothTreatment) => {
                                      return <span className="font-weight-500">{medicalStatuses.get(treatment.statusId!)?.displayName}</span>;
                                  }}
                                  title={<FormattedMessage id="condition"/>}/>
                    <Table.Column key="operation"
                                  render={(treatment: ToothTreatment) => <span className="font-weight-500">{medicalTreatments.get(treatment.treatmentId!)?.displayName}</span>}
                                  title={<FormattedMessage id="operation"/>}/>
                    <Table.Column key="tooth"
                                  render={(treatment: ToothTreatment) => <span className="font-weight-500">{treatment.tooth!.position}</span>}
                                  title={<FormattedMessage id="tooth"/>}/>
                </Table>
            </div>
        </>
    );
};

export default Treatments;
